export default function toFixed(value: number, fractionDigits = 2) {
  const decimal = Math.pow(10, fractionDigits);

  return Math.floor(value * decimal) / decimal;
}
